module.exports = __webpack_public_path__ + "static/media/1.5faa8707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/1.jpg
// module id = 419
// module chunks = 0